<template>
  <div id='dialog-box' @click="emotionfag=false;fontfag = false">
		<header>
			<div class="logo">
				<img src="../../static/img/LOGO.png" alt="">
				<img src="../../static/img/ttlogo.png" alt="">
			</div>
		</header>
		<div class="contentbody">
			<div class="con-left fl">
				<div :class="`container line${line}`">
					<loading />
					<div class="msg-container">
						<message-list />
					</div>
					<pc-input @lineChange="lineChange" @hidefag="showemotionbox" :emotionfag ='emotionfag'   @hidefag1="showfontbox" :fontfag ='fontfag'/>
				</div>
			</div>
			<div class="con-right fl">
                <div class="topbanner">东财保险·东方财富旗下保险平台</div>
                <div class="bottombanner">传播保险福祉，用心为客户缔造保险新体验。</div>
				<!-- <a target="_blank" href="https://trade.1234567.com.cn/reg/step1">&nbsp;</a> -->
			</div>
		</div>
    <net-error v-show="!netStatus"/>
	</div>
</template>

<script>
import NetError from '../components/NetError'
import MessageList from "../components/MessageList.1"
import PcInput from "../components/PcInput"
import Loading from "../components/Loading"



export default {
  name: "Pc",
  components: {
    MessageList,
    PcInput,
    Loading,
    NetError
  },
  data() {
    return {
      line: 1,
			emotionfag:false,
      fontfag:false,
      netStatus: true
    }
  },
  methods: {
    showemotionbox(val){
			this.$nextTick(() => {
				this.emotionfag = val;
			})
		},
		showfontbox(val){
			this.$nextTick(() => {
				this.fontfag = val;
			})
		},
    lineChange(val) {
      this.line = val;
      this.$nextTick(() => {
        Bus.$emit("msgListScrollToEnd");
      })
    },
    netWorkChange() {
      this.netStatus = navigator.onLine;
    }
  },
  mounted() {
    this.$nextTick(() => {
      Bus.$emit("initEvent", this.$route.query.sceneId || '');
      window.addEventListener('online',  this.netWorkChange);
      window.addEventListener('offline', this.netWorkChange);
    })
  }
}
</script>


<style>
 #dialog-box{
	position: absolute;
    overflow: hidden;
    width: 100%;
    background-clip: padding-box;
    font-size: 12px;
    color: #333;
    height: 100%;
    background: white;
	}
	header{
		background:#5b8bd5;
		height:60px;
	}
	header .logo {
		float: left;
		color: white;
		text-indent: 20px;
		-ms-text-shadow: 1px 1px 2px #0D0D0D, 0 0 5px #aaa;
		text-shadow: 1px 1px 2px #0D0D0D, 0 0 5px #aaa;
		vertical-align: central;
		display: inline-block;
		height: 60px;
		line-height: 60px;
	}
	header .logo img {
		vertical-align: middle;
	}
	.contentbody{
		min-height: 200px;
    min-width: 400px;
		background: white;
		position: absolute;
		height: 100%;
		top: 60px;
		bottom: 0;
		right: 0;
		left: 0;
	}
	.con-left{
		width: auto;
		position: absolute;
		top: 0px;
		left: 0;
		right: 170px;
		bottom: 0px;
	}
	.con-right{
		position: absolute;
		right: 0;
		width: 170px;
	}
	.con-right a {
		display: block;
		width: 120px;
		height: 240px;
		background: url('../assert/r.jpg');
		cursor: pointer;
		text-decoration: none;
		margin: 10px 0 0 10px;
	}

 .container {
   width: 100%;
   height: 100%;
   position: relative;
 }

 .msg-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 220px;
  }

  .line2 .msg-container {
    bottom: 220px;
  }


  .line2 .similarList{
    bottom: 100px;
		cursor: pointer;
  }

  .line2 .feedbackBtns{
    bottom: 100px;
  }

  .topbanner{
      background: #33588C;
      color: #ffffff;
      text-align: center;
      margin: 10px ;
      font-size: 14px;
      padding: 15px 10px;
  }
    .bottombanner{
        color: #666666;
        text-align: center;
        margin: 15px 10px;
         font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Pc.vue